// extracted by mini-css-extract-plugin
export default {"textHeader":"TextHeader_textHeader__AivNt","textTitle":"TextHeader_textTitle__kSLE6","textSummary":"TextHeader_textSummary__bOx9s"};